(() => {
  /**
   * Handle the centre symbol devil character spine animations
   */
  class CentreDevil extends PIXI.Container {
    constructor() {
      super();
      // asset name
      this._devilSpineName = "CentreDevil";
      this._symbolMap = null;
      this._matchSmb = null;

      // devil spine asset
      this._devilCharacterSpine = null;
      this._respinPopup = null;

      this._standardBGMovie = null;
      this._boostBGMovie = null;
      this._multiBGMovie = null;
      this._respinBGMovie = null;

      this._initialScale = 0.3;
      this._devilScale = 0.4;

      this._currentModiferBackgroundShowing = null;

      this._cycleBackgroundIndex = 0;
      this._cycleOutTween = null;
      this._cycleInTween = null;
      this._cycleInLandingSymbol = false;
      this._cycleInNextBackground = null;

      // idle loop counter for the devil(play blink anim 1 in 4 times)
      this._idleLoopCounter = 0;
      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    /**
     * Initialise the class
     */
    initialise() {
      this._devilContainer = resourceManager.get("centreDevil:CentreDevilContainer");
      this.createBackgroundSprites();

      this._devilCharacterSpine = resourceManager.createObject("spine", this._devilSpineName, this._devilContainer, {
        name: this._devilSpineName,
        defaultAnimation: "Symbol_Static",
        scaleX: 0.35,
        scaleY: 0.35,
        x: 0,
        y: -13,
      });

      // create respin asset
      this._respinPopup = resourceManager.createObject("sprite", "respinPopup", this._devilContainer, {
        fileName: "Symbols/Devil Symbols/Respin.png",
        anchor: 0.5,
        x: 0,
        y: -125,
        alpha: 0,
      });

      this._chestContainer = resourceManager.get("chestsContainer");
      this._devilCharacterSpine.visible = false;
      this.devilVisible = false;
      this.currentBg = this._standardBGMovie;

      this._symbolMap = new Map([
        [gameController.standardCollectSymbol, { key: "standard", color: "Normal", bg: this._standardBGMovie }],
        [gameController.boostCollectSymbol, { key: "boost", color: "Green", bg: this._boostBGMovie }],
        [gameController.multiplierCollectSymbol, { key: "multi", color: "Blue", bg: this._multiBGMovie }],
        [gameController.respinCollectSymbol, { key: "respin", color: "Red", bg: this._respinBGMovie }],
      ]);
    }

    /**
     * Get background by key
     */
    getBackgroundByKey(key) {
      for (const value of this._symbolMap.values()) {
        if (value.key === key) {
          return value.bg;
        }
      }
      return null;
    }

    /**
     * Create the background spines
     */
    createBackgroundSprites() {
      // background movies
      this._standardBGMovie = resourceManager.createObject("movie", "standardBGMovie", this._devilContainer, {
        definition: "devilCollectBackground",
        anchor: 0.5,
        y: -186,
        loop: true,
      });
      // create a mask to remove the horns underneath the anim
      this._standardBGMovieMask = new PIXI.Graphics();
      this._standardBGMovieMask.beginFill(0xff0000);
      this._standardBGMovieMask.drawRect(-85, -111, 168, 197);
      this._standardBGMovieMask.endFill();
      this._standardBGMovie.addChild(this._standardBGMovieMask);
      this._standardBGMovie.mask = this._standardBGMovieMask;

      this._boostBGMovie = resourceManager.createObject("movie", "boostBGMovie", this._devilContainer, {
        definition: "devilBoostBackground",
        anchor: 0.5,
        y: -186,
        loop: true,
      });
      // create a mask to remove the horns underneath the anim
      this._boostBGMovieMask = new PIXI.Graphics();
      this._boostBGMovieMask.beginFill(0xff0000);
      this._boostBGMovieMask.drawRect(-85, -111, 168, 197);
      this._boostBGMovieMask.endFill();
      this._boostBGMovie.addChild(this._boostBGMovieMask);
      this._boostBGMovie.mask = this._boostBGMovieMask;

      this._multiBGMovie = resourceManager.createObject("movie", "multiBGMovie", this._devilContainer, {
        definition: "devilMultiplierBackground",
        anchor: 0.5,
        y: -186,
        loop: true,
      });
      // create a mask to remove the horns underneath the anim
      this._multiBGMovieMask = new PIXI.Graphics();
      this._multiBGMovieMask.beginFill(0xff0000);
      this._multiBGMovieMask.drawRect(-85, -111, 168, 197);
      this._multiBGMovieMask.endFill();
      this._multiBGMovie.addChild(this._multiBGMovieMask);
      this._multiBGMovie.mask = this._multiBGMovieMask;

      this._respinBGMovie = resourceManager.createObject("movie", "respinBGMovie", this._devilContainer, {
        definition: "devilRespinBackground",
        anchor: 0.5,
        y: -186,
        loop: true,
      });
      // create a mask to remove the horns underneath the anim
      this._respinBGMovieMask = new PIXI.Graphics();
      this._respinBGMovieMask.beginFill(0xff0000);
      this._respinBGMovieMask.drawRect(-85, -111, 168, 197);
      this._respinBGMovieMask.endFill();
      this._respinBGMovie.addChild(this._respinBGMovieMask);
      this._respinBGMovie.mask = this._respinBGMovieMask;

      this._standardBGMovie.visible = false;
      this._boostBGMovie.visible = false;
      this._multiBGMovie.visible = false;
      this._respinBGMovie.visible = false;
      this._standardBGMovie.gotoAndStop(0);
      this._boostBGMovie.gotoAndStop(0);
      this._multiBGMovie.gotoAndStop(0);
      this._respinBGMovie.gotoAndStop(0);

      this._modifierBackgrounds = {
        standard: this._standardBGMovie,
        boost: this._boostBGMovie,
        multi: this._multiBGMovie,
        respin: this._respinBGMovie,
      };
    }

    /**
     * Grab the devil character spine assets
     */
    _onLayoutComplete() {}

    showAnimatedBackground() {
      let reelSymbol;

      const isBuyABonusFirstSpin = gameController.inBuyABonus && gameController.inBuyABonusFirstSpin;

      if (isBuyABonusFirstSpin || !gameController.convertedReelResults) {
        reelSymbol = gameController.standardCollectSymbol;
      } else {
        reelSymbol = gameController.convertedReelResults[gameController.devilReel][0];
      }

      this._matchSmb = this._symbolMap.get(reelSymbol);

      if (!this._matchSmb) return;

      if (gameController.inFreeSpins && !isBuyABonusFirstSpin) {
        if (this.currentBg !== this._matchSmb.bg) {
          this._fadeOutCurrentBgTween = gsap.fromTo(
            this.currentBg,
            { alpha: 1 },
            {
              alpha: 0,
              duration: 1,
              onComplete: () => {
                this.currentBg.visible = false;
                this._fadeOutCurrentBgTween = null;
              },
            }
          );

          const centreStatic = resourceManager.get("slotContainer:reelContainer:reel7");
          centreStatic.setReelSymbol(0, reelSymbol);
          this._staticFadeIn = gsap.fromTo(centreStatic.children[0], { alpha: 0 }, { alpha: 1, duration: 1 });

          this._matchSmb.bg.play();
          this._matchSmb.bg.visible = true;
          gameController.reelBorderFire.switchColour(this._matchSmb.color, 1);

          this._fadeInNewBgTween = gsap.fromTo(
            this._matchSmb.bg,
            { alpha: 0 },
            {
              alpha: 1,
              duration: 1,
              onComplete: () => {
                this.currentBg = this._matchSmb.bg;
                this._fadeInNewBgTween = null;
              },
            }
          );
        } else {
          this._currentModiferBackgroundShowing = this._matchSmb.key;
          this.currentBg.alpha = 1;
          this.currentBg.play();
          this.currentBg.visible = true;
        }
      } else {
        this.currentBg = this._matchSmb.bg;
        this._currentModiferBackgroundShowing = this._matchSmb.key;
        this.currentBg.alpha = 1;
        this.currentBg.play();
        this.currentBg.visible = true;
      }
    }

    slamStop() {
      if (this._fadeOutCurrentBgTween) {
        this._fadeOutCurrentBgTween.progress(1);
        this._fadeInNewBgTween.progress(1);
        gameController.reelBorderFire.slamStop();
      }
    }

    /**
     * Show the centre devil
     */
    appear() {
      this.showAnimatedBackground();
      this._devilCharacterSpine.visible = true;

      gsap.fromTo(
        this._devilCharacterSpine.scale,
        {
          x: 0.35,
          y: 0.35,
        },
        {
          duration: 0.25,
          x: 0.4,
          y: 0.4,
        }
      );
      gsap.fromTo(
        this._devilCharacterSpine,
        {
          y: -13,
        },
        {
          duration: 0.25,
          y: 0,
        }
      );
      this.devilVisible = true;
    }

    /**
     * Hide the centre devil
     */
    disappear(inFreeSpins) {
      if (!inFreeSpins) {
        this._devilCharacterSpine.visible = false;
        this.devilVisible = false;
        this.currentBg.visible = false;
        this.currentBg.gotoAndStop(0);
      }
    }

    /**
     * Alternate through the unlocked bonus colours
     */
    alternateModifierBackgrounds(currentUnlockedModifiers) {
      if (this._cycleOutTween) {
        this._cycleOutTween.kill();
        this._cycleOutTween = null;
      }
      if (this._cycleInTween) {
        this._cycleInTween.kill();
        this._cycleOutTween = null;
      }

      this._cyclingBackground = true;
      this._cycleBackgroundColours(["standard"].concat(currentUnlockedModifiers));
    }

    /**
     * Cycle background colours
     */
    async _cycleBackgroundColours(unlockedModifiers) {
      if (this._cyclingBackground) {
        this._cycleBackgroundIndex =
          (unlockedModifiers.indexOf(this._currentModiferBackgroundShowing) + 1) % unlockedModifiers.length;

        // Get current and previous modifier
        const cycleInModifier = unlockedModifiers[this._cycleBackgroundIndex];

        const cycleInBackground = this._cycleInLandingSymbol
          ? this.getBackgroundByKey(this._cycleInNextBackground)
          : this.getBackgroundByKey(cycleInModifier);
        const cycleOutBackground = this.getBackgroundByKey(this._currentModiferBackgroundShowing);

        if (cycleInBackground !== cycleOutBackground) {
          this._cycleOutTween = gsap.fromTo(cycleOutBackground, { alpha: 1 }, { alpha: 0, duration: 0.3 });
          this._cycleOutTween.then(() => cycleOutBackground.gotoAndStop(0));

          cycleInBackground.play();
          this._cycleInTween = gsap.fromTo(cycleInBackground, { alpha: 0 }, { alpha: 1, duration: 0.3 });
          cycleInBackground.visible = true;

          this._currentModiferBackgroundShowing = this._cycleInLandingSymbol
            ? this._cycleInNextBackground
            : cycleInModifier;
        }

        // Wait before cycling again
        await new Promise((res) => gsap.delayedCall(1, res));

        this._cycleBackgroundColours(unlockedModifiers);

        if (this._cycleInLandingSymbol) {
          this._cyclingBackground = false;
          this._cycleInLandingSymbol = false;
        }
      }
    }

    /**
     * Handle centre devil, check if collecting any coins, play appt animations
     */
    async handleCentreDevil() {
      if (!this.devilVisible) {
        this.appear();
      }

      const hasCoins = gameController.checkForCoinCollect();

      if (hasCoins) {
        if (gameController.hasRespun) {
          musicManager.onRespinsEnd();
          this.idleLoop();
        }
        this.collecting();
        await CoinsView.doCashCoins();
      }
    }

    /**
     * Play both chest add anim
     */
    async bothChests() {
      if (!this.devilVisible) {
        this.appear();
      }
      soundManager.play("devilFlamePoint");
      this._devilCharacterSpine.play("Symbol_Chest_Both", false, 0, () => {
        this._devilCharacterSpine.play("Symbol_Chest_Both_Reset", false, 0, () => {
          this.idleLoop();
        });
      });
    }

    /**
     * Play left chest add anim
     */
    leftChest() {
      if (!this.devilVisible) {
        this.appear();
      }
      soundManager.play("devilFlamePoint");
      this._devilCharacterSpine.play("Symbol_Chest_Left", false, 0, () => {
        this._devilCharacterSpine.play("Symbol_Chest_Left_Rest", false, 0, () => {
          this.idleLoop();
        });
      });
    }

    /**
     * Play right chest add anim
     */
    rightChest() {
      if (!this.devilVisible) {
        this.appear();
      }
      soundManager.play("devilFlamePoint");
      this._devilCharacterSpine.play("Symbol_Chest_Right", false, 0, () => {
        this._devilCharacterSpine.play("Symbol_Chest_Right_Reset", false, 0, () => {
          this.idleLoop();
        });
      });
    }

    /**
     * Play collecting anim
     */
    collecting() {
      if (!this.devilVisible) {
        this.appear();
      }
      musicManager.playDevilPositiveSound();
      this._devilCharacterSpine.play("Symbol_Collecting", true);
    }

    /**
     * Play dance anim
     */
    dance(loop = false) {
      // if (!this.devilVisible) {
      //   this.appear();
      // }
      this._devilCharacterSpine.play("Symbol_Dance_Level01", loop);
    }

    /**
     * Play fireball loop anim
     */
    fireballLoop() {
      if (!this.devilVisible) {
        this.appear();
      }
      soundManager.play("orbLoop");
      this._devilCharacterSpine.play("Symbol_Fireball_Loop", true);
    }

    /**
     * Play fireball outro anim
     */
    fireBallOutro() {
      if (!this.devilVisible) {
        this.appear();
      }
      this._devilCharacterSpine.play("Symbol_Fireball_Out");
    }

    /**
     * Play fireball intro anim
     */
    fireBallIntro() {
      if (!this.devilVisible) {
        this.appear();
      }
      soundManager.play("orbAppear");
      this._devilCharacterSpine.play("Symbol_Fireball_into", false, 0, () => {
        this.fireballLoop();
      });
    }

    /**
     * Play frustrated anim
     */
    frustrated() {
      if (!this.devilVisible) {
        this.appear();
      }

      gameController.devilCharacter.centreDevilLinkFrustrate();
      return new Promise((res) => {
        this._devilCharacterSpine.play("Symbol_Frustrated", false, 0, res);
      });
    }

    /**
     * Play idle loop anim
     */
    idleLoop() {
      if (!this.devilVisible) {
        this.appear();
      }
      this._devilCharacterSpine.play("Symbol_Idle01", false, 0, () => {
        this._idleLoopCounter++;
        if (this._idleLoopCounter === 4) {
          this._idleBlink();
        } else {
          this.idleLoop();
        }
      });
    }

    /**
     * Play idle blink anim
     */
    _idleBlink() {
      this._idleLoopCounter = 0;
      this._devilCharacterSpine.play("Symbol_Idle01_blink", false, 0, () => this.idleLoop());
    }

    /**
     * Respin intro
     */
    respinIntro() {
      return new Promise((resolve) => {
        this._devilCharacterSpine.play("Symbol_Fireball_into", false, 0, async () => {
          this._respinPopup.alpha = 1;
          musicManager.playDevilLaughSound();
          await gsap.fromTo(this._respinPopup.scale, { y: 0.2, x: 0.2 }, { y: 1, x: 1, duration: 1 });

          gsap.to(this._respinPopup.scale, { x: 2, y: 2, duration: 0.5 });
          await gsap.to(this._respinPopup, { alpha: 0, duration: 0.5 });

          musicManager.onRespinsStart();
          this.dance(true);
          gameController.devilCharacter.dance(-1);
          resolve();
        });
      });
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {}
  }

  resourceManager.registerObjectType(
    "centreDevil",
    () => new CentreDevil(),
    () => {},
    () => []
  );
})();
